import { Borrower } from '@api';
import {
    AttachMoney, Email, Person, PersonAdd
} from '@mui/icons-material';
import { Tooltip, Typography } from '@mui/material';
import { ReactElement } from 'react';

import styles from './BorrowerInfoTooltip.module.scss';


interface BorrowerInfoTooltipProps {
    children: ReactElement;
    borrower?: Borrower;
    isNewBorrower?: boolean;
}

export function BorrowerInfoTooltip({ children, borrower, isNewBorrower }: BorrowerInfoTooltipProps) {
    if (!borrower) {
        return children;
    }

    return (
        <Tooltip
            title={(
                <>
                    <div className={styles.root}>
                        {isNewBorrower ? (
                            <PersonAdd fontSize="small" />
                        ) : (
                            <Person fontSize="small" />
                        )}

                        <Typography
                            variant="subtitle2"
                            fontWeight="600"
                        >
                            {`${borrower.firstName || ''} ${borrower.middleName ? `${borrower.middleName} ` : ''}${borrower.lastName || ''}`}
                        </Typography>
                    </div>

                    <div className={styles.fields}>
                        {borrower.fico && (
                            <>
                                <Typography
                                    variant="caption"
                                >
                                    FICO:
                                </Typography>

                                <Typography variant="body2">
                                    {borrower.fico}
                                </Typography>
                            </>
                        )}

                        {borrower.ssn && (
                            <>
                                <Typography variant="caption">
                                    SSN:
                                </Typography>

                                <Typography variant="body2">
                                    *-{borrower.ssn.slice(-4)}
                                </Typography>
                            </>
                        )}

                        {borrower.email && (
                            <>
                                <Email fontSize="small" />

                                <Typography variant="body2">
                                    {borrower.email}
                                </Typography>
                            </>
                        )}

                        {borrower.primaryWageEarner !== undefined && (
                            <>
                                <AttachMoney fontSize="small" />

                                <Typography variant="body2">
                                    {borrower.primaryWageEarner ? 'Primary wage earner' : 'Not primary wage earner'}
                                </Typography>
                            </>
                        )}
                    </div>
                </>
            )}
            arrow
            placement="left"
        >
            {children}
        </Tooltip>
    );
}
